import React, { useState, useCallback } from 'react';
import Header from './components/Header';
import LocationSection from './components/LocationSection';
import RecommendationSection from './components/RecommendationSection';
import Footer from './components/Footer';
import KakaoMap from './components/KakaoMap';
import { LocationData } from './utils/locationService';
import './App.css';

type PlaceType = 'restaurant' | 'cafe';
type DistanceOption = 0.5 | 1.5 | 3;

function App() {
  const [locationData, setLocationData] = useState<LocationData | null>(null);
  const [showMap, setShowMap] = useState(false);
  const [restaurants, setRestaurants] = useState<any[]>([]);
  const [placeType, setPlaceType] = useState<PlaceType>('restaurant');
  const [distance, setDistance] = useState<DistanceOption>(1.5);

  // 위치 데이터가 설정되면 맵 표시
  const handleLocationUpdate = useCallback((location: LocationData) => {
    setLocationData(location);
    setShowMap(true);
  }, []);

  // 음식점 데이터 업데이트
  const handleRestaurantsUpdate = useCallback((restaurantList: any[]) => {
    setRestaurants(restaurantList);
  }, []);

  // 장소 타입 변경
  const handlePlaceTypeChange = (type: PlaceType) => {
    setPlaceType(type);
  };

  // 거리 옵션 변경
  const handleDistanceChange = (dist: DistanceOption) => {
    setDistance(dist);
  };

  // 카테고리 코드 가져오기
  const getCategoryCode = () => {
    return placeType === 'restaurant' ? 'FD6' : 'CE7';
  };

  return (
    <div className="App">
      <div className="mobile-container">
        <Header />
        <div className="content-sections">
          {/* 장소 타입 선택 탭 */}
          <div className="place-type-section">
            <div className="place-type-tabs">
              <button 
                className={`place-type-tab ${placeType === 'restaurant' ? 'active' : ''}`}
                onClick={() => handlePlaceTypeChange('restaurant')}
              >
                🍽️ 음식점
              </button>
              <button 
                className={`place-type-tab ${placeType === 'cafe' ? 'active' : ''}`}
                onClick={() => handlePlaceTypeChange('cafe')}
              >
                ☕ 카페
              </button>
            </div>
          </div>

          {/* 거리 옵션 선택 */}
          <div className="distance-section">
            <div className="distance-label">📏 검색 거리</div>
            <div className="distance-options">
              <button 
                className={`distance-option ${distance === 0.5 ? 'active' : ''}`}
                onClick={() => handleDistanceChange(0.5)}
              >
                500m
              </button>
              <button 
                className={`distance-option ${distance === 1.5 ? 'active' : ''}`}
                onClick={() => handleDistanceChange(1.5)}
              >
                1.5km
              </button>
              <button 
                className={`distance-option ${distance === 3 ? 'active' : ''}`}
                onClick={() => handleDistanceChange(3)}
              >
                3km
              </button>
            </div>
          </div>

          <LocationSection onLocationUpdate={handleLocationUpdate} />
          
          {/* 위치 설정 후 카카오맵 표시 */}
          {showMap && locationData && (
            <div className="map-section">
              <h3 className="section-title">
                🗺️ 주변 {placeType === 'restaurant' ? '음식점' : '카페'}
              </h3>
              <KakaoMap 
                latitude={locationData.latitude}
                longitude={locationData.longitude}
                level={3}
                categoryCode={getCategoryCode()}
                distance={distance}
                onRestaurantsUpdate={handleRestaurantsUpdate}
              />
            </div>
          )}
          
          <RecommendationSection restaurants={restaurants} placeType={placeType} />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
